import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bradwestfall/Desktop/ReactTraining/Projects/monorepo/reacttraining.com/src/page-templates/BlogArticlePage.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div>
  <p className="align-center text-large">
    So, you want to start a blog in 2019?
  </p>
    </div>
    <p>{`With free hosting options like `}<a parentName="p" {...{
        "href": "https://firebase.google.com/docs/hosting/quickstart"
      }}>{`Firebase Hosting`}</a>{` (what we use), `}<a parentName="p" {...{
        "href": "netlify.com"
      }}>{`Netlify`}</a>{`, `}<a parentName="p" {...{
        "href": "https://pages.github.com"
      }}>{`GitHub Pages`}</a>{` and Static Site generators like `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org"
      }}>{`Gatsby`}</a>{` and `}<a parentName="p" {...{
        "href": "https://nextjs.org"
      }}>{`NextJS`}</a>{` for React, hosting and building your own powerful blog is a lot easier these days. You just need a few command-line skills.`}</p>
    <p>{`Also, these steps happen to be how we setup `}<a parentName="p" {...{
        "href": "https://reacttraining.com/blog"
      }}>{`our new blog here at React Training`}</a>{`. In this article I'll assume that you are already somewhat familiar with:`}</p>
    <ul>
      <li parentName="ul">{`React`}</li>
      <li parentName="ul">{`Markdown`}</li>
      <li parentName="ul">{`Very basic JavaScript`}</li>
      <li parentName="ul">{`Command line stuff like NPM`}</li>
    </ul>
    <h3 {...{
      "id": "just-show-me-the-code"
    }}><a parentName="h3" {...{
        "href": "#just-show-me-the-code",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Just show me the code!`}</h3>
    <p>{`This is what we're building: `}<a parentName="p" {...{
        "href": "https://github.com/bradwestfall/gatsby-mdx-blog"
      }}>{`https://github.com/bradwestfall/gatsby-mdx-blog`}</a></p>
    <h2 {...{
      "id": "what-is-mdx"
    }}><a parentName="h2" {...{
        "href": "#what-is-mdx",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`What is MDX?`}</h2>
    <p>{`Many static site generators use `}<a parentName="p" {...{
        "href": "https://daringfireball.net/projects/markdown/syntax"
      }}>{`Markdown`}</a>{` for content. MDX is a superset of Markdown that lets you `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`import`}</code>{` and render React components!`}</p>
    <p>{`Check it out:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "markdown"
    }}><pre parentName="div" {...{
        "className": "language-markdown"
      }}><code parentName="pre" {...{
          "className": "language-markdown"
        }}>{`import CustomComponent from './CustomComponent'

`}<span parentName="code" {...{
            "className": "token title important"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`#`}</span>{` Here is our markdown header`}</span>{`

Here is a markdown paragraph.

`}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`CustomComponent`}</span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`/>`}</span></span>{`

More markdown content.`}</code></pre></div>
    <p>{`The magic of MDX is that it knows how to treat the above file as a Markdown file but also as a JavaScript module in the sense that it can import and use React's JSX.`}</p>
    <h2 {...{
      "id": "using-mdx-with-gatsby"
    }}><a parentName="h2" {...{
        "href": "#using-mdx-with-gatsby",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Using MDX with Gatsby`}</h2>
    <p>{`Even though MDX isn't Gatsby-specific, this article is about setting up MDX with Gatsby specifically and some of the hurdles you might face. After all, MDX is still fairly new.`}</p>
    <p>{`To start, let's install Gatsby. These steps will be somewhat terse so if you're looking for more detail, be sure to review the `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/tutorial"
      }}>{`Official Setup Guide`}</a></p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`# Globally install Gatsby's Command-Line API`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` i -g gatsby-cli

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# Make sure it installed. We're using v2 for this article`}</span>{`
gatsby --version`}</code></pre></div>
    <p>{`The next step is to generate the Gatsby site based on a "starter" -- which is just their term for a GitHub repo that gives you a nice starting point for a Gatsby project. There are `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/starters"
      }}>{`many starters you can choose from`}</a>{`, but we'll be using the most basic one:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`gatsby new my-blog https://github.com/gatsbyjs/gatsby-starter-default`}</code></pre></div>
    <p>{`Now you can `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`cd my-blog`}</code>{` and run the blog using `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`npm start`}</code>{`. If you examine `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`package.json`}</code>{` you'll see that this is just an alias to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby develop`}</code>{`.`}</p>
    <p>{`If all went well, you should be able to go to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`localhost:8000`}</code>{` to see your Gatsby site.`}</p>
    <h2 {...{
      "id": "mdx-hello-world"
    }}><a parentName="h2" {...{
        "href": "#mdx-hello-world",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`MDX "Hello World"`}</h2>
    <p>{`Next, install these three packages for using MDX with Gatsby:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` i gatsby-mdx @mdx-js/mdx @mdx-js/tag`}</code></pre></div>
    <p>{`Let's create a basic "hello world" for MDX to make sure it's working.`}</p>
    <p>{`First open up the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-config.js`}</code>{` file on the root of the project. This is a configuration file where we can add plugins to Gatsby. Installing a plugin might remind you of Babel plugins where often times we just need to do the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`npm install`}</code>{` and then add the name of the plugin to the config array:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "json"
    }}><pre parentName="div" {...{
        "className": "language-json"
      }}><code parentName="pre" {...{
          "className": "language-json"
        }}><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token property"
          }}>{`"siteMetadata"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  `}<span parentName="code" {...{
            "className": "token property"
          }}>{`"plugins"`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"gatsby-mdx"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Next, go to the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pages`}</code>{` folder and create a new folder called `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/blog`}</code>{` with a file called `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`first-blog-post.mdx`}</code>{`. Be sure to put some valid Markdown in the file for testing:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`/pages
 └─ /blog
     └─ first-blog-post.mdx`}</code></pre></div>
    <p>{`You should be able to go to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`localhost:8000/blog/first-blog-post`}</code>{` to see the rendered result of the Markdown in that file.`}</p>
    <p>{`If you're having issues, you may have forgotten to do `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`npm start`}</code>{` again after installing those packages in the steps above.`}</p>
    <h2 {...{
      "id": "nested-layouts-and-routes"
    }}><a parentName="h2" {...{
        "href": "#nested-layouts-and-routes",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Nested Layouts and Routes`}</h2>
    <p>{`If you're new to Gatsby but you have some experience with React Router, you might be wondering how nested layouts work. After all, based on what we just learned we can see that URL routes are generated automatically by filename convention and the folder structure of anything inside of `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pages`}</code>{`. This is far different from conventional React where something like React Router is manually configured within layouts to eventually work it's way down to a page (in an top-to-bottom approach).`}</p>
    <p>{`Gatsby takes more of a bottom-up approach by focusing on the pages first and then wrapping them in any number of layouts.`}</p>
    <p>{`For example, look at the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pages/index.js`}</code>{` file (which is the home page). You'll see that it's wrapped in a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`<Layout>`}</code>{`. In theory, you could have primary layouts and sub-layouts by using similar wrapping techniques.`}</p>
    <p>{`Keep in mind this is just a the default starter for Gatsby and is not meant to be the only way you should do things. Feel free to change these existing pages and layouts to your liking.`}</p>
    <h3 {...{
      "id": "where-do-we-write-the-html-file"
    }}><a parentName="h3" {...{
        "href": "#where-do-we-write-the-html-file",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Where do we write the HTML file?`}</h3>
    <p>{`We don't. Gatsby handles all of that for us and lets us focus on pages. This might leave you wondering "How can I change the contents of `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`<head>`}</code>{` like meta tags since I don't have direct access to an `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`index.html`}</code>{` file?"`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/nfl/react-helmet"
      }}><code parentName="a" {...{
          "className": "language-text"
        }}>{`react-helmet`}</code></a>{` is a great tool for solving this. It lets you add a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`<Helmet>`}</code>{` element anywhere in your React code and it will put those values in the document's `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`<head>`}</code>{`. In theory you can add stuff like this your your layout:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "jsx"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Helmet`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
  `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`title`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`My Custom Title`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`title`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
  `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`meta`}</span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`name`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`description`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`content`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`My Blog's Description`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`/>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Helmet`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span></code></pre></div>
    <blockquote>
      <p parentName="blockquote">{`The Gatsby Starter we used does a few more steps though. They abstract `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`<Helmet>`}</code>{` away into an `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`<SEO>`}</code>{` element and then they populate it with props and content that exists in `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`gatsby-config.js`}</code>{`. You can probably follow the trail from `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`pages/index.js`}</code>{` to see how they use `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`<SEO>`}</code>{`. As with layouts, feel free to customize or simplify this strategy however you see fit.`}</p>
    </blockquote>
    <h2 {...{
      "id": "mdx-layouts"
    }}><a parentName="h2" {...{
        "href": "#mdx-layouts",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`MDX Layouts`}</h2>
    <p>{`Layouts for MDX pages are a bit different. We let Gatsby know what layout to use for MDX files in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-config.js`}</code>{`. This change to our configuration indicates we want to find `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.mdx`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.md`}</code>{` files and to render their contents into `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`blog-post-layout.js`}</code>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}>{`plugins`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    resolve`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`gatsby-mdx`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    options`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Apply gatsby-mdx to both .mdx and .md files`}</span>{`
      extensions`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'.mdx'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'.md'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
      defaultLayout`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` require`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`resolve`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'./src/components/blog-post-layout.js'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`...`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span></code></pre></div>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Important!`}</strong>{` Previously the plugin for `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`gatsby-mdx`}</code>{` was just a string in the array. That's fine unless you want to add options like we do now. When options are required of a plugin, we use an object instead of a string. The plugin name goes in the `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`resolve`}</code>{` property like above.`}</p>
    </blockquote>
    <p>{`The above configuration states that we want the contents of any Markdown or MDX file to be put into our `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`<BlogPostLayout>`}</code>{` element (via `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`props.children`}</code>{`), seen here:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "jsx"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// src/components/blog-post-layout.js`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` React `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` Layout `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'./layout'`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`BlogPostLayout`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` children `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
    `}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Layout`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
      `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`article`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
        `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`header`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
          `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`h1`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`Todo: Main Title Will Go Here`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`h1`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
        `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`header`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
        `}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`children`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
      `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`article`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
    `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Layout`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`default`}</span>{` BlogPostLayout`}</code></pre></div>
    <p>{`We could call this a "sub-layout" since it also wrapps itself in the main layout.`}</p>
    <h2 {...{
      "id": "frontmatter"
    }}><a parentName="h2" {...{
        "href": "#frontmatter",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Frontmatter`}</h2>
    <p>{`"Frontmatter" is a strange word unless you've used a Markdown-based static site generator before. Frontmatter is meta data in `}<a parentName="p" {...{
        "href": "https://yaml.org/"
      }}>{`YAML format`}</a>{` that goes at the beginning of the Markdown file (or MDX in our case). Apparently the word `}<a parentName="p" {...{
        "href": "https://en.wiktionary.org/wiki/front_matter"
      }}>{`comes from traditional paperback books`}</a>{` and I first heard the term when using `}<a parentName="p" {...{
        "href": "https://jekyllrb.com/"
      }}>{`Jekyll`}</a>{` years ago -- one of the first really popular static-site generators from the folks at GitHub.`}</p>
    <p>{`Here's what it looks like:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "markdown"
    }}><pre parentName="div" {...{
        "className": "language-markdown"
      }}><code parentName="pre" {...{
          "className": "language-markdown"
        }}><span parentName="code" {...{
            "className": "token hr punctuation"
          }}>{`---`}</span>{`
title: First Blog Post
author: Brad Westfall
date: 2019-02-05

`}<span parentName="code" {...{
            "className": "token hr punctuation"
          }}>{`---`}</span>{`

The above area fenced in by three hashes is frontmatter. Below it (this paragraph) is Markdown.`}</code></pre></div>
    {
      /* Blog Note: The frontmatter has to have a space before the last --- or
          it will be interpreted as a Markdown heading */
    }
    <p>{`The frontmatter goes at the top of the MDX file but doesn't get rendered there. Remember it's just meta information to be used elsewhere.`}</p>
    <p>{`The most common usecase for frontmatter is to give data to the post's layout. The `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-mdx`}</code>{` plugin we setup earlier is what's responsible for providing the MDX file to our layout. It also sends along frontmatter as props. Let's now adjust the layout to receive them:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "jsx"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// src/components/blog-post-layout.js`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` React `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` Helmet `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react-helmet'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` Layout `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'./layout'`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`BlogPostLayout`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` children`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` pageContext `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` title`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` author`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` date `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` pageContext`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`frontmatter
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
    `}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Layout`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
      `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Helmet`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
        `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`title`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`title`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`title`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
      `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Helmet`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
      `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`article`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
        `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`header`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
          `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`h1`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`title`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`h1`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
          `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`span`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`Author: `}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`author`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`span`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
          `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`time`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`Date: `}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`date`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`time`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
        `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`header`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
        `}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`children`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
      `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`article`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
    `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Layout`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`default`}</span>{` BlogPostLayout`}</code></pre></div>
    <p>{`Now we can make up any frontmatter we want to use in the layout. At `}<a parentName="p" {...{
        "href": "https://reacttraining.com/blog"
      }}>{`the React Training blog`}</a>{`, we use frontmatter to pass an image URL to the layout for the "banner" section at the top. We also pass meta-tag info for `}<a parentName="p" {...{
        "href": "http://ogp.me"
      }}>{`Open Graph`}</a>{` social sharing -- just to give you some ideas.`}</p>
    <h2 {...{
      "id": "browsing-blog-posts"
    }}><a parentName="h2" {...{
        "href": "#browsing-blog-posts",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Browsing Blog Posts`}</h2>
    <p>{`This is where things start to get really interesting and it's also where Gatsby's use of GraphQL starts to help us. Even though Gatsby has server-side rendering (SSR), this is not to say it has a production server that is going to dynamically render pages for us on each request. Instead, Gatsby generates a bunch of static pages when we run `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby build`}</code>{`. During the build, Gatsby gathers meta information about our site and makes it available to our pages via GraphQL. This allows us to create a page for browsing all blog posts that feels as if it were a server-side dynamic page, but actually it's just another static pages.`}</p>
    <p>{`Here's what we need to do to make our "Browse Blog Posts" page:`}</p>
    <h3 {...{
      "id": "step-1-source-the-blog-posts"
    }}><a parentName="h3" {...{
        "href": "#step-1-source-the-blog-posts",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Step 1: Source the blog posts`}</h3>
    <p>{`In `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-config.js`}</code>{`, add this new section into the plugins array:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}>{`plugins`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    resolve`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`gatsby-source-filesystem`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    options`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      name`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`blog`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
      path`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token interpolation-punctuation punctuation"
              }}>{`\${`}</span>{`__dirname`}<span parentName="span" {...{
                "className": "token interpolation-punctuation punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`/src/pages/blog`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`...`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span></code></pre></div>
    <p>{`You'll notice that there's already an entry for `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/sourcing-from-the-filesystem"
      }}><code parentName="a" {...{
          "className": "language-text"
        }}>{`gatsby-source-filesystem`}</code></a>{` in the plugins which is sourcing images. It's totally fine (and intended) to use this plugin multiple times for sourcing different information from the filesystem for different purposes, so don't change the existing entry. Add the above entry for sourcing files in the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pages/blog`}</code>{` folder.`}</p>
    <p>{`This new entry tells Gatsby to read our files to make some of their metadata available to GraphQL in the next steps.`}</p>
    <h3 {...{
      "id": "step-2-graphql-and-our-first-dynamic-page"
    }}><a parentName="h3" {...{
        "href": "#step-2-graphql-and-our-first-dynamic-page",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Step 2: GraphQL and our first "dynamic" page`}</h3>
    <p>{`Add a new page at `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`src/pages/blog/index.js`}</code>{` that uses GraphQL to query information from the previous step so we can make our listing of posts:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "jsx"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// src/components/blog/index.js`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` React `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` graphql`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` Link `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'gatsby'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` Layout `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'../../components/layout'`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`BlogIndex`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` data `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` edges`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` posts `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` data`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`allMdx
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
    `}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Layout`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
      `}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`posts`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`map`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` node `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` title`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` author `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`frontmatter
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
          `}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`div`}</span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`key`}</span><span parentName="span" {...{
              "className": "token script language-javascript"
            }}><span parentName="span" {...{
                "className": "token script-punctuation punctuation"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`node`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`id`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
            `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`header`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
              `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`title`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
              `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`Posting By `}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`author`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
            `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`header`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
            `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`p`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`excerpt`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`p`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
            `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Link`}</span></span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`to`}</span><span parentName="span" {...{
              "className": "token script language-javascript"
            }}><span parentName="span" {...{
                "className": "token script-punctuation punctuation"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`node`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`fields`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`slug`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`View Article`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Link`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
            `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`hr`}</span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`/>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
          `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
        `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
    `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Layout`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`default`}</span>{` BlogIndex

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` pageQuery `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` graphql`}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`
  query blogIndex {
    allMdx {
      edges {
        node {
          id
          excerpt
          fields {
            slug
          }
          frontmatter {
            title
            author
          }
        }
      }
    }
  }
`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span></code></pre></div>
    <blockquote>
      <p parentName="blockquote">{`Note: This file will not work until Step 3 below.`}</p>
    </blockquote>
    <p>{`You may have noticed there are two exports: a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`default`}</code>{` and a named (`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pageQuery`}</code>{`) export. The named export is how we tell Gatsby what data we need to render this page. In this query we want to single out MDX files. If you're brand new to GraphQL, `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/querying-with-graphql"
      }}>{`here is a good resource`}</a>{` to learn how to use GraphQL with Gatsby.`}</p>
    <p>{`By convention the two exports are meant to work together. The query will be parsed first to gather information and then results are fed into React component as props (the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`default`}</code>{` export).`}</p>
    <blockquote>
      <p parentName="blockquote">{`Note that I've only included two frontmatter fields in my query, so that's the only one I'll receive in my props.`}</p>
    </blockquote>
    <p>{`For the purposes of Gatsby and GraphQL, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`node`}</code>{` basically means "page". In `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`node`}</code>{`, there are more things we can query for besides `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`id`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`excerpt`}</code>{`, and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`frontmatter`}</code>{`. You can explore all of them with the built-in `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/introducing-graphiql/"
      }}>{`GraphiQL Dashboard`}</a>{`. However, the one thing we queried for which breaks the code so far is the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`fields { slug }`}</code>{`. This is because `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`fields`}</code>{` is not given to us by default. If you were to run the code now, you would get this error: `}<em parentName="p">{`Cannot query field "fields" on type "Mdx"`}</em>{`. Let's fix this.`}</p>
    <h3 {...{
      "id": "step-3-creating-a-slug"
    }}><a parentName="h3" {...{
        "href": "#step-3-creating-a-slug",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Step 3: Creating a "Slug"`}</h3>
    <p>{`Since a slug is not provided to us by default when we use `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-mdx`}</code>{` with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-source-filesystem`}</code>{`, we'll have to make one for ourselves.`}</p>
    <p>{`This gives us a chance to take our first look at `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-node.js`}</code>{` which is an empty file at this point. This file allows us to get access to Gatsby's API functions at build-time and to make the server do things for us that it doesn't do by default. We can create dynamic pages (which we'll cover later) or add more stuff that can be queried with GraphQL.`}</p>
    <p>{`Add this code to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-node.js`}</code>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` createFilePath `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`require`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'gatsby-source-filesystem'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Here we're adding extra stuff to the "node" (like the slug)`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// so we can query later for all blogs and get their slug`}</span>{`
exports`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`onCreateNode`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` node`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` actions`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` getNode `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` createNodeField `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` actions
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`internal`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`type `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`===`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Mdx'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` value `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`createFilePath`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` getNode `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token function"
          }}>{`createNodeField`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Individual MDX node`}</span>{`
      node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
      `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Name of the field you are adding`}</span>{`
      name`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'slug'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
      `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Generated value based on filepath with "blog" prefix`}</span>{`
      value`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`/blog`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token interpolation-punctuation punctuation"
              }}>{`\${`}</span>{`value`}<span parentName="span" {...{
                "className": "token interpolation-punctuation punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`It might not make total sense at first, but if you `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/node-apis"
      }}>{`read about the `}<strong parentName="a">{`gatsby-node.js`}</strong>{` file`}</a>{` you'll quickly learn about APIs like `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`createNodeField`}</code>{`, which allows us to add arbitrary fields to our nodes (pages) so GraphQL can query for them later. Then we can use the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`createFilePath`}</code>{` function from `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-source-filesystem`}</code>{` to make a slug based on the MDX filename.`}</p>
    <p>{`If you restart Gatsby you should be able to go to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`localhost:8000/blog`}</code>{` to see your new page that browses blog posts. The error goes away because GraphQL can now query for `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`fields`}</code>{` of MDX nodes.`}</p>
    <h2 {...{
      "id": "pagination"
    }}><a parentName="h2" {...{
        "href": "#pagination",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Pagination`}</h2>
    <p>{`The next step is to create pagination for browsing posts. There are many ways we can do this -- for example we could take our existing `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`BlogIndex`}</code>{` we just made and use some URL variable to determine how to iterate over the results. This might feel more like traditional pagination with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`?page=1`}</code>{` in the URL, but this technique isn't great for SSR and our static pages because there isn't a "real" page to visit for page 2, 3, etc.`}</p>
    <p>{`What we want is a bonafide static page for each of the paginated pages as if we had handmade `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pages/blog/1.js`}</code>{` and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pages/blog/2.js`}</code>{` etc. We can't really get this effect with one file like `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pages/blog/index.js`}</code>{` because anything we put in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pages`}</code>{` is a 1:1 mapping to a URI. Instead let's remove `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pages/blog/index.js`}</code>{` and tell Gatsby to build pages even though they don't exist in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pages`}</code>{`. We can do this programmatically with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-node.js`}</code>{` and GraphQL.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Even though we're removing the first strategy, I'm glad we covered how to create a basic page that reads from GraphQL, but the new strategy will be better for pagination. At least most of it's contents are re-usable in the new strategy.`}</p>
    </blockquote>
    <p>{`Open `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-node.js`}</code>{` and add this to what we already have:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` path `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`require`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'path'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Programmatically create the pages for browsing blog posts`}</span>{`
exports`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`createPages`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` graphql`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` actions `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` createPage `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` actions
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`graphql`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`
    query {
      allMdx(sort: { order: DESC, fields: [frontmatter___date] }) {
        edges {
          node {
            id
            excerpt(pruneLength: 250)
            fields {
              slug
            }
            frontmatter {
              title
              author
            }
          }
        }
      }
    }
  `}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`then`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`results`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` errors`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`errors`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` Promise`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`reject`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`errors`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` posts `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` results`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`data`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`allMdx`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`edges

    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// This little algo takes the array of posts and groups`}</span>{`
    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// them based on this \`size\`:`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` size `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`10`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` start `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span>{`
    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Premake the grouped array to the correct length. new Array`}</span>{`
    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// wasn't working with map so don't @ me :)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` groupedPosts `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` Array`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`from`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`Array`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`Math`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`ceil`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`posts`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`length `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span>{` size`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    groupedPosts `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` groupedPosts`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`map`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` group `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` posts`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`slice`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`start`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` start `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` size`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
      start `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+=`}</span>{` size
      `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` group
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Here's the basic idea of what the grouping is doing if the`}</span>{`
    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// size variable was 2:`}</span>{`
    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// posts: [post1, post2, post3]`}</span>{`
    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// groupedPosts: [[post1, post2], [post3]]`}</span>{`

    groupedPosts`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`forEach`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`group`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` index`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` page `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` index `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
      `}<span parentName="code" {...{
            "className": "token function"
          }}>{`createPage`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        path`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`/blog/`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token interpolation-punctuation punctuation"
              }}>{`\${`}</span>{`page`}<span parentName="span" {...{
                "className": "token interpolation-punctuation punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
        component`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` path`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`resolve`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'./src/components/browse-blog-posts.js'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
        context`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` groupedPosts`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` group`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` page `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`That's quite a bit to read and understand. Here's the gist of what's happening:`}</p>
    <ol>
      <li parentName="ol">{`Gatsby calls `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`createPages()`}</code>{` automatically for us (if it exists).`}</li>
      <li parentName="ol">{`Then we use GraphQL to get all of our MDX posts.`}</li>
      <li parentName="ol">{`Next, get an array of posts and group them by page.`}</li>
      <li parentName="ol">{`Then use the `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`createPage`}</code>{` API to build a page at `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`/blog/1`}</code>{`, `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`/blog/2`}</code>{`, etc. Note that context just lets us pass down props into the `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`browse-blog-posts.js`}</code>{` component which we'll make next.`}</li>
    </ol>
    <h3 {...{
      "id": "create-srccomponentsbrowse-blog-postsjs"
    }}><a parentName="h3" {...{
        "href": "#create-srccomponentsbrowse-blog-postsjs",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Create `}<code parentName="h3" {...{
        "className": "language-text"
      }}>{`src/components/browse-blog-posts.js`}</code></h3>
    <p>{`The file is very reminiscent of the previous index file but now it doesn't need it's own GraphQL query because it receives the posts data through props passed in from `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`createPage`}</code>{` in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-node.js`}</code>{`. The new file has the same basic purpose, to make an index page of posts, only now we'll be creating several of them for each page of the pagination.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "jsx"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// src/components/browse-blog-posts.js`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` React `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` Link `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'gatsby'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` Layout `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'./layout'`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`BrowseBlogPosts`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` pageContext `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` groupedPosts`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` group`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` page `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` pageContext
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
    `}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Layout`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
      `}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`group`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`map`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` node `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` title`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` author `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`frontmatter
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
          `}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`div`}</span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`key`}</span><span parentName="span" {...{
              "className": "token script language-javascript"
            }}><span parentName="span" {...{
                "className": "token script-punctuation punctuation"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`node`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`id`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
            `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`header`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
              `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`title`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
              `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`Posting By `}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`author`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
            `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`header`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
            `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`p`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`excerpt`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`p`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
            `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Link`}</span></span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`to`}</span><span parentName="span" {...{
              "className": "token script language-javascript"
            }}><span parentName="span" {...{
                "className": "token script-punctuation punctuation"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`node`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`fields`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`slug`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`View Article`}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Link`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
            `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`hr`}</span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`/>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
          `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
        `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
      `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`footer`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
        Pages:`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`' '`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
        `}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`groupedPosts`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`map`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`x`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` index`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
          `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` currentPage `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` index `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
          `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
            `}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Link`}</span></span>{`
              `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`key`}</span><span parentName="span" {...{
              "className": "token script language-javascript"
            }}><span parentName="span" {...{
                "className": "token script-punctuation punctuation"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`index`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`
              `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`to`}</span><span parentName="span" {...{
              "className": "token script language-javascript"
            }}><span parentName="span" {...{
                "className": "token script-punctuation punctuation"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span><span parentName="span" {...{
                "className": "token template-string"
              }}><span parentName="span" {...{
                  "className": "token template-punctuation string"
                }}>{`\``}</span><span parentName="span" {...{
                  "className": "token string"
                }}>{`/blog/`}</span><span parentName="span" {...{
                  "className": "token interpolation"
                }}><span parentName="span" {...{
                    "className": "token interpolation-punctuation punctuation"
                  }}>{`\${`}</span>{`currentPage`}<span parentName="span" {...{
                    "className": "token interpolation-punctuation punctuation"
                  }}>{`}`}</span></span><span parentName="span" {...{
                  "className": "token template-punctuation string"
                }}>{`\``}</span></span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`
              `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`className`}</span><span parentName="span" {...{
              "className": "token script language-javascript"
            }}><span parentName="span" {...{
                "className": "token script-punctuation punctuation"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`currentPage `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`===`}</span>{` page `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`?`}</span>{` `}<span parentName="span" {...{
                "className": "token string"
              }}>{`'active'`}</span>{` `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`null`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`
            `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
              `}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`index `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
            `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Link`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
          `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
        `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
      `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`footer`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
    `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Layout`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`default`}</span>{` BrowseBlogPosts`}</code></pre></div>
    <blockquote>
      <p parentName="blockquote">{`Remember to remove `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`src/pages/blog/index.js`}</code>{` and to do a full Gatsby restart anytime you change `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`gatsby-node.js`}</code></p>
    </blockquote>
    <p>{`That's it. You should be able to browse to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/blog/1`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/blog/2`}</code>{` (if you have enough posts to fill up more than one page). Be sure to redirect from `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/blog`}</code>{` to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/blog/1`}</code>{`. There are lots of different ways and plugins to do this in Gatsby so we'll let you choose one that's suiting.`}</p>
    <h2 {...{
      "id": "closing-remarks"
    }}><a parentName="h2" {...{
        "href": "#closing-remarks",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Closing Remarks`}</h2>
    <p>{`You made it to the end! This tutorial is a bit long, but all these details were new to me until I had to dive head-first into Gatsby and MDX, so hopefully it helps to clarify some things.`}</p>
    <h3 {...{
      "id": "speaking-of-remark"
    }}><a parentName="h3" {...{
        "href": "#speaking-of-remark",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Speaking of "remark"`}</h3>
    <p>{`MDX uses `}<a parentName="p" {...{
        "href": "https://remark.js.org/"
      }}>{`Remark`}</a>{` as the underlying engine for processing Markdown. As such, we can use a variety of Remark plugins like this:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}>{`plugins`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    resolve`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`gatsby-mdx`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    options`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      extensions`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'.mdx'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'.md'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
      defaultLayout`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` require`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`resolve`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'./src/components/blog-post-layout.js'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
      mdPlugins`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
        `}<span parentName="code" {...{
            "className": "token function"
          }}>{`require`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'remark-images'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
        `}<span parentName="code" {...{
            "className": "token function"
          }}>{`require`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'remark-emoji'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
        `}<span parentName="code" {...{
            "className": "token function"
          }}>{`require`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'remark-slug'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
        `}<span parentName="code" {...{
            "className": "token function"
          }}>{`require`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'remark-autolink-headings'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`...`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span></code></pre></div>
    <p>{`Checkout this `}<a parentName="p" {...{
        "href": "https://github.com/remarkjs/remark/blob/master/doc/plugins.md"
      }}>{`giant list of plugins`}</a></p>
    <h2 {...{
      "id": "syntax-highlighting-with-prismjs"
    }}><a parentName="h2" {...{
        "href": "#syntax-highlighting-with-prismjs",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Syntax Highlighting with PrismJS`}</h2>
    <p>{`It was a little tricky to get proper syntax highlighting working. If you poke around there are several ways suggested to get Gatsby working with Prism but most are for ordinary Remark-based Markdown. For MDX, there is a plugin called `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-remark-prismjs`}</code>{` but at the time of this writing, I could only get it work work if I installed `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-mdx@0.1.4`}</code>{` with the plugin setup like this:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "json"
    }}><pre parentName="div" {...{
        "className": "language-json"
      }}><code parentName="pre" {...{
          "className": "language-json"
        }}><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  resolve`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` \`gatsby-mdx\``}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  options`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    extensions`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`'.mdx'`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` '.md'`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    defaultLayout`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` require.resolve('./src/components/blog-post-layout.js')`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    gatsbyRemarkPlugins`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        resolve`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` \`gatsby-remark-prismjs\``}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
        options`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
          classPrefix`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` 'language-'`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
          inlineCodeMarker`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token null keyword"
          }}>{`null`}</span>{`
        `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      